type PaginationCounts = {
  current_page?: number;
  last_page?: number;
  total?: number;
  per_page?: number;
  from?: number | null;
  to?: number | null;
};

export const getPaginationData = (pagination?: PaginationCounts | null) => {
  return {
    currentPage: pagination?.current_page || 1,
    totalPages: pagination?.last_page || 0,
    totalItems: pagination?.total || 0,
    itemsPerPage: pagination?.per_page || 0,
  };
};
